import defaultSections from "./defaultFrameworkSections.json";

export { defaultSections };
export const DEFAULT_BY_ID = Object.fromEntries(defaultSections.map((s) => [s.id, s]));

export function slugifyId(text) {
  return (text || "section")
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "_")
    .replace(/^_|_$/g, "")
    .slice(0, 40) || "section";
}
